import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Input, Output, ViewEncapsulation, EventEmitter, OnInit, Inject, AfterViewInit, HostListener, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.less'],
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule],
  encapsulation: ViewEncapsulation.None
})
export class SearchModalComponent implements OnInit, OnChanges{
  @Input() public searchItems!: any;
  @Input() public isSearchOpen!: any;
  @Output() public closeSearch = new EventEmitter<boolean>();
  searchText = '';


  constructor(private router: Router, @Inject(DOCUMENT) private dom: Document, private commonService: CommonService ) {}

  ngOnInit(): void {
    this.searchText = '';
  }

  ngOnChanges(): void {
    if (!this.commonService.isPlatformBrowser()) return;
    const searchInput = this.dom.getElementById('search-input');
    if (searchInput) {
      searchInput.focus();
    }
  }

  onSubmit() {
    if (!this.searchText.trim()) {
      return;
    }
    this.router.navigate(['/search-results'], {
      queryParams: {
        q: this.searchText,
      },
      queryParamsHandling: "merge"
    });
    this.isSearchOpen = false;
    this.closeSearch.emit(false);
  }

}
